<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock :title="titreListe">
        <v-subheader>{{ titreAtelier }}</v-subheader>
        <v-row v-if="etudiants.length > 0">
          <v-col cols="12">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="etudiants"
              :show-select="isAtelierEchu(atelier)"
              disable-pagination
              hide-default-footer
              item-key="id"
              class="elevation-2"
            >
              <template v-slot:item.dateNaissance="{ item }">
                {{ formatDate(item.dateNaissance) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" offset="0" offset-md="3">
            <div class="text-center">
              <v-btn
                v-if="isAtelierEchu(atelier)"
                class="mx-2"
                color="primary"
                @click="enregistrer"
                :loading="loading"
              >
                <v-icon left>save</v-icon>Enregistrer l'émargement
              </v-btn>
              <router-link
                :to="{
                  name: 'gestion-presences-ateliers'
                }"
                tag="v-btn"
              >
                <v-icon title="Retour"></v-icon>
                Retour</router-link
              >
            </div>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
import ApiAtelierRepository from "@/repositories/ApiAtelierRepository";
import moment from "moment";

export default {
  name: "EmargementAtelier",
  components: { BaseBlock },
  props: ["idAtelier"],

  data() {
    return {
      headers: [
        {
          text: "Nom",
          align: "left",
          sortable: true,
          value: "nom"
        },
        {
          text: "Prénom",
          align: "left",
          sortable: false,
          value: "prenom"
        },
        {
          text: "Date de naissance",
          align: "center",
          sortable: true,
          value: "dateNaissance"
        },
        {
          text: "Mail",
          align: "center",
          sortable: true,
          value: "mail"
        }
      ],
      etudiants: [],
      atelier: {},
      loading: false,
      selected: []
    };
  },
  computed: {
    titreListe() {
      return this.isAtelierEchu(this.atelier)
        ? "Liste d'émargement"
        : "Liste des inscrits";
    },
    titreAtelier() {
      return this.atelier.id
        ? "Atelier du " +
            this.formatDateEtHeure(this.atelier.dateDebut) +
            " sur le campus  " +
            this.atelier.campus.libelle +
            " (" +
            this.atelier.lieu +
            ")"
        : "";
    }
  },
  async created() {
    if (this.idAtelier > 0) {
      await this.getAtelier(this.idAtelier);
      await this.getEtudiants();
    }
  },
  methods: {
    async getEtudiants() {
      try {
        const etudiants = await ApiEtudiantRepository.getInscritsAtelier(
          this.idAtelier
        );
        this.etudiants = etudiants;
        this.selected = [];
        this.etudiants.forEach(etudiant => {
          if (etudiant.presenceAtelier) this.selected.push(etudiant);
        });
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDateEtHeure(dateEtHeure) {
      return moment(dateEtHeure).format("DD/MM/YYYY HH:mm");
    },
    async getAtelier(id) {
      try {
        const atelier = await ApiAtelierRepository.getAtelier(id);
        this.atelier = atelier;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async enregistrer() {
      this.loading = true;
      this.etudiants.forEach(etudiant => {
        if (this.selected.includes(etudiant, 0)) {
          etudiant.presenceAtelier = true;
        } else {
          etudiant.presenceAtelier = false;
        }
      });
      try {
        await ApiEtudiantRepository.setEmargementAtelier(this.etudiants);
        this.$toast.success("Émargement enregistré " + this.titreAtelier);
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loading = false;
        this.$router.push({ name: "gestion-presences-ateliers" });
      }
    },
    isAtelierEchu(atelier) {
      return atelier.dateDebut
        ? moment() > moment(atelier.dateDebut)
          ? true
          : false
        : false;
    }
  }
};
</script>
